<template>
  <div
    :class="[
      'h-100',
      {
        min_height_100: messages.length <= 1,
        min_height_185: !isMobileView && messages.length > 1,
        min_height_270: isMobileView && messages.length > 1,
      },
    ]"
  >
    <perfect-scrollbar
      v-if="isMobileView"
      :options="{ suppressScrollX: true, swipeEasing: true }"
      class="mobile position-absolute w-100"
    >
      <b-list-group flush>
        <message-mobile-list-item
          v-for="message in messages"
          :key="message.id"
          :message="message"
          @open="$emit('open', $event)"
        />
      </b-list-group>
    </perfect-scrollbar>
    <template v-else>
      <b-row no-gutters class="font-weight-bold mt-2">
        <b-col
          cols="4"
          class="d-flex justify-content-start justify-content-xl-center"
        >
          To/From
        </b-col>
        <b-col cols="5" xl="4" class="d-flex justify-content-center">
          Subject
        </b-col>
        <b-col
          cols="3"
          xl="4"
          class="d-flex justify-content-end justify-content-xl-center"
        >
          Date
        </b-col>
      </b-row>
      <perfect-scrollbar
        :options="{ suppressScrollX: true, swipeEasing: true }"
        class="position-absolute w-100"
      >
        <b-list-group>
          <message-list-item
            v-for="message in messages"
            :key="message.id"
            :message="message"
            @open="handleOpen"
          />
        </b-list-group>
      </perfect-scrollbar>
      <div class="close-btn-wrapper d-flex justify-content-end" v-if="!isMssRecruiter">
        <b-button variant="v3_teal_outline" @click="$emit('close-message-list')">
          Close
        </b-button>
      </div>
    </template>
  </div>
</template>

<script>
import MessageListItem from '@/components/messages/MessageListItem';
import MessageMobileListItem from '@/components/messages/MessageMobileListItem';

export default {
  name: 'MessagesList',
  props: {
    messages: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    MessageListItem,
    MessageMobileListItem,
  },
  computed: {
    isMobileView: function () {
      return this.windowWidth < 768;
    },
    isMssRecruiter: function () {
      return this.$store.getters.userIsMSSRecruiter;
    },
  },
  methods: {
    handleOpen: function (...args) {
      this.$emit('open', ...args);
    },
  },
};
</script>

<style scoped lang="scss">
.ps {
  min-height: 110px;
  max-height: 60%;
  max-width: 96%;
  padding-right: 15px;
  overflow-x: hidden;
  &.mobile {
    min-height: 250px;
    max-height: 75%;
    max-width: 96%;
  }
}
.close-btn-wrapper {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>
